import focacce from './img/focacce.png';
import pizzaOven from './img/pizza.png';
import mortadella from './img/mortadella.png';
import pizzaVeggie from './img/pizza-veggie.png';
import pizzaMeat from './img/pizza-meat.png';
import lingua from './img/lingua.png';
import pizzella from './img/pizzella.png';
import mozarella from './img/mozzarella.png';
import prosciutto from './img/prosciutto.png';
import vegan from './img/vegan.png';
import frittata from './img/frittata.png';
import frittataProsciutto from './img/frittata-prosciutto.png';
import spianata from './img/spianata.png';
import tuna from './img/tuna.png';
import salads from './img/salads.png';
import basicSalad from './img/salad.png';
import greekSalad from './img/greek-salad.png';
import pastaSalad from './img/pasta-salad.png';
import lasagne from './img/lasagne.png';
import lasagnaBolognese from './img/lasagna.png';
import lasagnaVeggie from './img/lasagna-veggie.png';
import fcp from './img/fcp.png';
import panini from './img/panini.png';
import hotdog from './img/hotdog.png';

import './App.css';
import { Text, Grid, Card, Textarea, Button, Link, Tooltip } from '@geist-ui/core';
import { useEffect, useState } from 'react';

function TitleRow({ title, img }) {
  return (
    <div className='row title-row'>
      <img src={img} height={'58px'} width={'58px'} alt={title} />
      <Text font={'2rem'} b ml={1}>{title}</Text>
    </div>
  );
}

function ProductCard({ name, text, img }) {

  const [count, setCount] = useState(0);
  useEffect(() => {
    handleAnyClick();
  }, [count])

  const handleClick = e => {
    setCount(count + 1);
  };

  const handleRightClick = e => {
    e.preventDefault();
    setCount(Math.max(count - 1, 0));
  }

  let bgc = (count > 0 ) ? 'rgba(14, 108, 212, 0.92)' : 'rgba(152, 14, 14, 0.882)';

  return (
    <Grid xs={8} md={8} lg={6} >
      <Card className='product-card' width='100%' shadow onClick={handleClick} onContextMenu={handleRightClick} id={name} data-product={text} data-amount={count}>
        <Tooltip text={text} type="dark" style={{ aspectRatio: 1, display: 'flex', placeContent: 'center', placeItems: 'center', width: '100%', height: '100%' }}>
          <img src={img} alt={name} />
        </Tooltip>
        <div className='product-card-counter' style={{backgroundColor: bgc}}>{count}</div>
      </Card>
    </Grid>
  );
}

function ProductGrid({ children }) {
  return (
    <Grid.Container className='product-grid' gap={2} justify="center">{children}</Grid.Container>
  );
}

const handleAnyClick = e => {
  const allWithClass = Array.from(
    document.getElementsByClassName('product-card')
  );
  let x = allWithClass.filter((el) => el.dataset.amount > 0);
  let out = "";
  x.forEach(product => {
    out += product.dataset.amount + " x " + product.dataset.product + "\n";
  });
  document.getElementById('output').value = out;
}

const handleCopy = e => {
  e.preventDefault();
  let out = document.getElementById('output').value;
  navigator.clipboard.writeText(out);
  alert("Copied the text:\n\n" + out);
}

function App() {

  return (
    <div className="App">

      <Text b font={'1.8rem'} mb={0} mx={2}>ItaLuncher</Text>
      <Text style={{ color: '#ccc' }} small font={'1rem'} mb={2} mx={2}>A very specific tool for a very specific group</Text>

      <Grid.Container width="100%" height="100%" gap={4} justify="center">
        <Grid width="100%" className='struct-grid' xs={24} sm={12} md={8}>
          <TitleRow title={'Focacce'} img={focacce} />
          <ProductGrid
            children={
              <>
                <ProductCard name={'Mortadella'} text={'Focaccia Mortadella'} img={mortadella} />
                <ProductCard name={'Mozzarella & Verdure'} text={'Focaccia Mozarella & Verdure'} img={mozarella} />
                <ProductCard name={'Prosciutto & Mozarella'} text={'Focaccia Prosciutto & Mozarella'} img={prosciutto} />
                <ProductCard name={'Vegan'} text={'Focaccia Vegan'} img={vegan} />
                <ProductCard name={'Spianata'} text={'Focaccia Spianata & Rucola'} img={spianata} />
                <ProductCard name={'Frittata'} text={'Focaccia Frittata'} img={frittata} />
                <ProductCard name={'Frittata & Prosciutto'} text={'Focaccia Frittata & Prosciutto'} img={frittataProsciutto} />
                <ProductCard name={'Tuna'} text={'Focaccia Tonno'} img={tuna} />
              </>
            }
          />
        </Grid>
        <Grid width="100%" className='struct-grid' xs={24} sm={12} md={8}>
          <TitleRow title={'Pizze'} img={pizzaOven} />
          <ProductGrid
            children={
              <>
                <ProductCard name={'Pizza Veggie'} text={'Pizza Vegetariana'} img={pizzaVeggie} />
                <ProductCard name={'Pizza'} text={'Pizza w/ Meat'} img={pizzaMeat} />
                <ProductCard name={'Pizella'} text={'Pizella'} img={pizzella} />
                <ProductCard name={'Lingua'} text={'Lingua'} img={lingua} />
              </>
            }
          />
        </Grid>
        <Grid width="100%" className='struct-grid' xs={24} sm={12} md={8}>
          <TitleRow title={'Panini'} img={panini} />
          <ProductGrid
            children={
              <>
                <ProductCard name={'Formaggi - Cetriolo - Pomodoro'} text={'Panino Formaggi, Cetriolo & Pomodoro'} img={fcp} />
                <ProductCard name={'Frittata'} text={'Panino Frittata'} img={frittata} />
                <ProductCard name={'Frittata & Prosciutto'} text={'Panino Frittata & Prosciutto'} img={frittataProsciutto} />
                <ProductCard name={'Tuna'} text={'Panino Tonno'} img={tuna} />
                <ProductCard name={'Hotdog'} text={'Hotdog'} img={hotdog} />
              </>
            }
          />
        </Grid>
        <Grid width="100%" className='struct-grid' xs={24} sm={12} md={8}>
          <TitleRow title={'Insalate'} img={salads} />
          <ProductGrid
            children={
              <>
                <ProductCard name={'Basic Salad'} text={'Basic Salad'} img={basicSalad} />
                <ProductCard name={'Greek Salad'} text={'Greek Salad'} img={greekSalad} />
                <ProductCard name={'Pasta Salad'} text={'Pasta Salad'} img={pastaSalad} />
              </>
            }
          />
        </Grid>
        <Grid width="100%" className='struct-grid' xs={24} sm={12} md={8}>
          <TitleRow title={'Lasagne'} img={lasagne} />
          <ProductGrid
            children={
              <>
                <ProductCard name={'Lasagna Bolognese'} text={'Lasagna Bolognese'} img={lasagnaBolognese} />
                <ProductCard name={'Veggie Lasagna'} text={'Lasagna Vegetariana'} img={lasagnaVeggie} />
              </>
            }
          />
        </Grid>
        <Grid width="100%" className='struct-grid' xs={24} sm={12} md={8}>
          <Textarea width="100%" height='100%' id='output' readOnly placeholder="The output message will appear here." mb={0.6} />
          <Grid.Container gap={1} justify='center' >
            <Grid xs={12} justify='center'>
              <Button auto width="30%" mx="5px" onClick={() => window.location.reload(false)}>Reset</Button>
              <Button auto width="30%" mx="5px" disabled>Download</Button>
              <Button auto width="30%" mx="5px" onClick={handleCopy}>Copy</Button>
            </Grid>
          </Grid.Container>
        </Grid>
      </Grid.Container>

      <Text small font={'0.85rem'} mx={2} my={2}>Made with 🍕 by <Link href='https://orhunulusahin.com'>OU</Link> with icons from <Link href="https://flaticon.com" target='_blank'>Flaticon</Link></Text>

    </div>
  );
}

export default App;
